import React from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Avatar, Dropdown, Menu, Select } from "antd";
import FontIcon from "../components/YhIcon";
import { useHistory } from "react-router-dom";
import useGlobalModel from "../model/globalModel";
import useNavModel from "../model/navModel";
import Logo from "@/assets/images/header-logo.png"
import { loginServiceAuth2 } from "@/views/login/LoginServiceAuth2";
import { mianCode, CLIENT_APP_CODE } from "@/utils/constants";
import { closeWebPage } from "@/utils/utils";

const { Header } = Layout;
const { Option } = Select;
function VrmHeader() {
    const history = useHistory();
    const { user, cm, toggleMenu, setUser, language, setLanguage, } = useGlobalModel();
    const { initNav } = useNavModel();
    //退出登录
    const onLogout = () => {
        if (user.loginType === "account") {
            setUser({ ...user, token: "" });
            history.push("/login");
            loginServiceAuth2.Logout();
            loginServiceAuth2.recordAppLogoutInfo(CLIENT_APP_CODE, user.userCode ?? "");
            initNav()
        } else {
            closeWebPage()

        }
        // setUser({ ...user, token: "" });
        // history.push("/login");
        // loginServiceAuth2.Logout();
        // initNav()
        // loginServiceAuth2.recordAppLogoutInfo(mianCode,user.userCode);



    };
    // 菜单项
    const HeaderMenu = () => {
        const onClearCache = () => {
            initNav()
        }
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onClearCache}>关闭所有标签</span>
                </Menu.Item>
                {/* <Menu.Divider /> */}
            </Menu>
        )
    }
    const countryAll: any = {
        "vrm-sa": "-沙特",
        "vrm-nga-yh": "-尼日",

    }
    return (
        <Header className="layout-section-header">
            {/* 左侧按钮 */}
            <div className="layout-sider-logo">
                <img className="layout-sider-logo-img" src={Logo} alt="财务管理系统Logo" />
                <span className="one-line">{`云修${countryAll[mianCode]}(云豪)管理系统`}</span>
            </div>
            {/* 右侧内容 */}
            <div className="header-right" style={{ paddingRight: "15px", }}>
                <Select
                    style={{ width: "100px", marginRight: "15px" }}
                    defaultValue={language}
                    onChange={(value) => { setLanguage(value) }}
                    options={[{ label: "中文", value: "zh-CN" }, { label: "English", value: "en-US" }]}
                >
                </Select>
                {/* 设置 */}
                <Dropdown overlay={HeaderMenu} placement="bottomCenter" trigger={['click']}>
                    <Avatar className="header-right-item config-icon" icon={<FontIcon type="icon-shezhi" />} />
                </Dropdown>

                {/* 登录用户信息 */}
                <span onClick={e => e.preventDefault()} className="header-right-item user-info">
                    <Avatar
                        size="default"
                        src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                        className="user-icon"
                    />
                    <span className="account">{user.username ? user.username : "未获取到"}</span>
                </span>

                {/* 退出登录 */}
                <FontIcon type="icon-tuichu" className="header-right-item logout-icon" onClick={onLogout} />
            </div>
        </Header>
    )
}

export default VrmHeader;